/* RESPONSIBLE TEAM: team-help-desk-experience */
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import type RouterService from '@ember/routing/router-service';
import type Transition from '@ember/routing/transition';
import { inject as service } from '@ember/service';

export default class MultilingualRoute extends WorkspaceSettingsRoute {
  @service declare router: RouterService;

  async beforeModel(transition: Transition) {
    await super.beforeModel(transition);
    let app = this.modelFor('apps.app') as {
      canViewMultilingualGlossaryPage: boolean;
    };

    if (!app.canViewMultilingualGlossaryPage) {
      return this.router.transitionTo('apps.app.settings.workspace.general');
    }
    return;
  }
}
